import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Btn from '@mlb/react-patterns/components/Button/button.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';

const ScrollContainerParent = styled.div`
    overflow: hidden;
`;

const ScrollContainerChild = styled.div`
    overflow: auto;
    margin-bottom: -25px;
    padding-bottom: 25px;
`;

const Button = styled(Btn).attrs(props => ({
    size: 'sm',
    iconName: props.name,
    shape: 'pill',
    styleName: 'default',
    iconSize: 16,
    hasHover: false,
}))`
    height: 38px;
    width: 38px;
    background: ${COLORS.linkBlueOnDark};
    display: block;
    position: absolute;
    right: ${(props) => props.right ? '-19px' : 'auto'};
    left: ${(props) => props.left ? '-19px': 'auto'};
    top: 0;
    bottom: 0;
    margin: auto;
    padding: 0;
    transform: translateY(-50%);
    border-radius: 50%;
    z-index: 1;
`;

const PopoverScroll = (props) => {

    let scrollContainerRef = React.useRef(null);

    const {
        dropZoneRef,
        dropZonePaddingLeft,
    } = props;

    const [
        setting,
        setSetting,
    ] = React.useState({
        currentClip: 0,
        clips: [],
        showLeft: false,
        showRight: false,
    });

    React.useEffect(() => {

        scrollContainerRef.current.addEventListener('scroll', setScrollSettings);
        window.addEventListener('resize', setScrollSettings);

        return () => {

            scrollContainerRef.current.removeEventListener('scroll', setScrollSettings);
            window.removeEventListener('resize', setScrollSettings);

        };

    }, []);

    React.useEffect(() => {

        setScrollSettings();

    }, [dropZoneRef.current?.children.length]);

    const setScrollSettings = () => {

        if (dropZoneRef.current.children.length > 0) {

            const currentScrollLeft = scrollContainerRef.current.scrollLeft;

            let currentClip = setting.currentClip;

            const clips = [];

            for (let div of dropZoneRef.current.children) {

                const startPosition = div.offsetLeft - dropZonePaddingLeft;
                const endPosition = div.offsetLeft + div.offsetWidth;

                clips.push([
                    startPosition,
                    endPosition,
                ]);

                const isClipCut = currentScrollLeft > startPosition && currentScrollLeft < endPosition;

                if (currentScrollLeft === startPosition || isClipCut) {

                    currentClip = isClipCut ? clips.length : clips.length - 1;

                }

            }

            const offsetRight = dropZoneRef.current.offsetWidth - (scrollContainerRef.current.offsetWidth + currentScrollLeft);

            setSetting({
                currentClip,
                clips,
                showLeft: currentClip > 0,
                showRight: offsetRight > 0,
            });

        }

    };

    const moveScroll = (direction) => {

        let currentClip = setting.currentClip;
        const clips = setting.clips;

        const currentScrollLeft = scrollContainerRef.current.scrollLeft;

        for (var i = 0; i < clips.length; i++) {

            const [
                startPosition,
                endPosition,
            ] = clips[i];

            const isClipCut = currentScrollLeft > startPosition && currentScrollLeft < endPosition;

            if (currentScrollLeft == startPosition || isClipCut) {

                currentClip = isClipCut ? i + 1 : i;

                if (direction === 'next') {

                    currentClip++;

                } else if (direction === 'previous') {

                    currentClip--;

                }

            }

        }

        scrollContainerRef.current.scrollTo({
            left: clips[currentClip][0],
            behavior: 'smooth',
        });

    };

    const leftArrow = setting.showLeft ? (
        <Button
            name={'arrow-previous'}
            left={true}
            handlers={{
                onClick: (e) => {

                    moveScroll('previous');
                    e.stopPropagation();

                },
            }}
        />
    ) : null;

    const rightArrow = setting.showRight ? (
        <Button
            name={'arrow-next'}
            right={true}
            handlers={{
                onClick: (e) => {

                    moveScroll('next');
                    e.stopPropagation();

                },
            }}
        />
    ) : null;


    return (
        <ScrollContainerParent>
            <ScrollContainerChild ref={scrollContainerRef}>
                {leftArrow}
                {props.children}
                {rightArrow}
            </ScrollContainerChild>
        </ScrollContainerParent>
    );

};

PopoverScroll.propTypes = {
    dropZoneRef: PropTypes.object.isRequired,
    dropZonePaddingLeft: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
};

export default PopoverScroll;
